(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/order-table.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/order-table.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const _svs$ui$reactTable = svs.ui.reactTable,
  Table = _svs$ui$reactTable.Table,
  TableRow = _svs$ui$reactTable.TableRow,
  TableBody = _svs$ui$reactTable.TableBody,
  TableHeader = _svs$ui$reactTable.TableHeader,
  TableHead = _svs$ui$reactTable.TableHead;
const _svs$ticket_partner$m = svs.ticket_partner.myOrders.constants.TEXTS.TABLE_HEADER,
  NAME = _svs$ticket_partner$m.NAME,
  COUNT = _svs$ticket_partner$m.COUNT,
  PRICE = _svs$ticket_partner$m.PRICE,
  VALID_UNTIL = _svs$ticket_partner$m.VALID_UNTIL;
const OrderTableRow = svs.ticket_partner.myOrders.components.OrderTableRow;
const OrderSum = svs.ticket_partner.myOrders.components.OrderSum;
const OrderTable = _ref => {
  let batches = _ref.batches;
  return React.createElement(Table, {
    large: true,
    striped: true
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableHeader, null, NAME), React.createElement(TableHeader, null, COUNT), React.createElement(TableHeader, null, VALID_UNTIL), React.createElement(TableHeader, null, PRICE))), React.createElement(TableBody, null, batches === null || batches === void 0 ? void 0 : batches.map((batch, i) => React.createElement(OrderTableRow, _extends({
    key: _.uniqueId(i)
  }, batch))), React.createElement(OrderSum, {
    batches: batches
  })));
};
svs.ticket_partner.myOrders.components.OrderTable = OrderTable;

 })(window);